/* Velune theme scripts */
(function () {
  'use strict';

  var V = window.velune || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Money ---------------------------------------------------------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || V.moneyFormat || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(re); var v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(re, v);
  }
  window.velune = V; V.formatMoney = formatMoney;

  /* Announcement rotator + countdown ------------------------------------ */
  $$('[data-announcement]').forEach(function (bar) {
    var msgs = $$('.announcement__msg', bar); var i = 0;
    if (msgs.length > 1) {
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, parseInt(bar.dataset.speed || '4', 10) * 1000);
    }
  });
  $$('[data-countdown]').forEach(function (el) {
    var end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) { el.hidden = true; return; }
    var h = $('[data-h]', el), m = $('[data-m]', el), s = $('[data-s]', el), d = $('[data-d]', el);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = end - Date.now();
      // Real deadline only: once it passes, the timer hides itself.
      if (diff <= 0) { el.hidden = true; return; }
      var days = Math.floor(diff / 864e5);
      var hrs = Math.floor((diff % 864e5) / 36e5);
      if (d) { d.textContent = days; d.parentNode.hidden = days === 0; }
      else hrs += days * 24;
      h.textContent = pad(hrs);
      m.textContent = pad(Math.floor((diff % 36e5) / 6e4));
      s.textContent = pad(Math.floor((diff % 6e4) / 1e3));
      setTimeout(tick, 1000);
    }
    tick();
  });

  /* Mobile nav ----------------------------------------------------------- */
  var mnav = $('[data-mobile-nav]');
  $$('[data-open-menu]').forEach(function (b) { b.addEventListener('click', function () { mnav && mnav.classList.add('is-open'); }); });
  $$('[data-close-menu]').forEach(function (b) { b.addEventListener('click', function () { mnav && mnav.classList.remove('is-open'); }); });

  /* Quantity inputs ------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-btn]');
    if (!b || b.closest('[data-cart-drawer]')) return;
    var input = b.parentNode.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v = b.dataset.qtyBtn === 'plus' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Gallery -------------------------------------------------------------- */
  $$('[data-gallery]').forEach(function (g) {
    var vp = $('[data-gallery-viewport]', g);
    var slides = $$('[data-media-id]', vp);
    var thumbs = $$('[data-thumb]', g);
    var dots = $$('[data-dot]', g);
    function setActive(idx) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      dots.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
    }
    function go(idx) {
      idx = Math.max(0, Math.min(slides.length - 1, idx));
      vp.scrollTo({ left: slides[idx].offsetLeft - vp.offsetLeft, behavior: 'smooth' });
      setActive(idx);
    }
    var current = function () { return Math.round(vp.scrollLeft / vp.clientWidth); };
    vp.addEventListener('scroll', function () { setActive(current()); }, { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    dots.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var p = $('[data-gallery-prev]', g), n = $('[data-gallery-next]', g);
    p && p.addEventListener('click', function () { go(current() - 1); });
    n && n.addEventListener('click', function () { go(current() + 1); });
    g.goToMedia = function (mediaId) {
      var i = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
      if (i > -1) go(i);
    };
  });

  /* Product form + variants --------------------------------------------- */
  $$('[data-product]').forEach(function (root) {
    var json = $('[data-product-json]', root);
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var form = $('form[data-product-form]', root);
    var idInput = form && $('input[name="id"]', form);
    var gallery = $('[data-gallery]', root);
    var sticky = $('[data-sticky-atc]');

    function findVariant(id) { return product.variants.find(function (v) { return v.id === Number(id); }); }

    function updateUI(variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      $$('[data-price]', document).forEach(function (el) { el.textContent = formatMoney(variant.price); });
      $$('[data-compare-price]', document).forEach(function (el) {
        var show = variant.compare_at_price && variant.compare_at_price > variant.price;
        el.textContent = show ? formatMoney(variant.compare_at_price) : '';
        el.hidden = !show;
      });
      $$('[data-save]', document).forEach(function (el) {
        var show = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (show) {
          var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          el.textContent = (el.dataset.prefix || 'Save') + ' ' + pct + '%';
        }
        el.hidden = !show;
      });
      $$('[data-add-btn]', document).forEach(function (btn) {
        btn.disabled = !variant.available;
        var label = $('[data-add-label]', btn) || btn;
        label.textContent = variant.available ? (btn.dataset.label || V.strings.addToCart) : V.strings.soldOut;
      });
      $$('.bundle', root).forEach(function (b) {
        var input = $('input', b);
        b.classList.toggle('is-selected', input && Number(input.value) === variant.id);
      });
      if (gallery && gallery.goToMedia && variant.featured_media) gallery.goToMedia(variant.featured_media.id);
      if (root.dataset.updateUrl === 'true' && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    // Bundle cards (single-option products)
    $$('[data-bundle-input]', root).forEach(function (input) {
      input.addEventListener('change', function () { updateUI(findVariant(input.value)); });
    });

    // Dropdowns (multi-option products)
    var selects = $$('[data-option-select]', root);
    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var opts = selects.map(function (s) { return s.value; });
        var v = product.variants.find(function (variant) {
          return variant.options.every(function (o, i) { return o === opts[i]; });
        });
        if (v) updateUI(v);
        else $$('[data-add-btn]', document).forEach(function (b) { b.disabled = true; ($('[data-add-label]', b) || b).textContent = V.strings.unavailable; });
      });
    });

    if (idInput) updateUI(findVariant(idInput.value));

    if (form) form.addEventListener('submit', function (e) {
      if (V.cartType !== 'drawer') return;
      e.preventDefault();
      addToCart(new FormData(form), $$('[data-add-btn]', document));
    });

    // Sticky add to cart: shows once the main buy button scrolls out of view.
    if (sticky && form) {
      var mainBtn = $('[data-add-btn]', form);
      if ('IntersectionObserver' in window && mainBtn) {
        var io = new IntersectionObserver(function (entries) {
          var e = entries[0];
          sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
        io.observe(mainBtn);
      }
      var sbtn = $('[data-sticky-add]', sticky);
      sbtn && sbtn.addEventListener('click', function () {
        if (V.cartType !== 'drawer') { form.requestSubmit ? form.requestSubmit() : form.submit(); return; }
        addToCart(new FormData(form), $$('[data-add-btn]', document));
      });
    }
  });

  /* Cart ----------------------------------------------------------------- */
  // The drawer is a Shopify section (sections/cart-drawer.liquid). After every change we ask Shopify to
  // re-render it (Section Rendering API), so all Theme settings > Cart options always apply.
  var drawer = $('[data-cart-drawer]');
  var SECTION = 'cart-drawer';

  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  document.addEventListener('click', function (e) { if (e.target.closest('[data-close-cart]')) closeDrawer(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); mnav && mnav.classList.remove('is-open'); } });
  $$('[data-open-cart]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      if (V.cartType !== 'drawer' || !drawer) return;
      e.preventDefault(); refreshCart().then(openDrawer);
    });
  });

  function setBusy(btns, busy) {
    btns.forEach(function (b) {
      var label = $('[data-add-label]', b) || b;
      if (busy) { b.dataset.prev = label.textContent; label.textContent = V.strings.adding; b.disabled = true; }
      else { label.textContent = b.dataset.prev || V.strings.addToCart; b.disabled = false; }
    });
  }

  function applySection(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer-inner]');
    if (drawer && fresh) {
      var cur = $('[data-cart-drawer-inner]', drawer);
      cur.innerHTML = fresh.innerHTML;
      cur.dataset.cartCountValue = fresh.dataset.cartCountValue;
    }
    var count = fresh ? fresh.dataset.cartCountValue : null;
    if (count != null) $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.dataset.count = count; });
  }

  function refreshCart() {
    return fetch(window.routes.root_url + '?sections=' + SECTION, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { applySection(d[SECTION]); });
  }

  function addToCart(formData, btns) {
    setBusy(btns, true);
    formData.append('sections', SECTION);
    formData.append('sections_url', window.location.pathname);
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (d) {
        if (d.sections) applySection(d.sections[SECTION]); else return refreshCart();
      })
      .then(function () { setBusy(btns, false); if (V.cartOpenOnAdd !== false) openDrawer(); })
      .catch(function (err) { setBusy(btns, false); alert((err && (err.description || err.message)) || 'Could not add to cart.'); });
  }

  function changeLine(line, qty) {
    var inner = drawer && $('[data-cart-drawer-inner]', drawer);
    inner && inner.classList.add('is-loading');
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: [SECTION], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); })
      .then(function (d) { if (d.sections) applySection(d.sections[SECTION]); else return refreshCart(); })
      .finally(function () { var i = drawer && $('[data-cart-drawer-inner]', drawer); i && i.classList.remove('is-loading'); });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var line = e.target.closest('[data-cart-line]');
      if (!line) return;
      var n = Number(line.dataset.cartLine);
      var input = $('input', line);
      if (e.target.closest('[data-remove]')) changeLine(n, 0);
      var b = e.target.closest('[data-qty-btn]');
      if (b) {
        var q = parseInt(input.value, 10) || 0;
        changeLine(n, b.dataset.qtyBtn === 'plus' ? q + 1 : Math.max(0, q - 1));
      }
    });
    drawer.addEventListener('change', function (e) {
      var line = e.target.closest('[data-cart-line]');
      if (line && e.target.matches('input')) changeLine(Number(line.dataset.cartLine), Math.max(0, parseInt(e.target.value, 10) || 0));
    });
    drawer.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-upsell-form]');
      if (!f) return;
      e.preventDefault();
      addToCart(new FormData(f), $$('[data-upsell-btn]', f));
    });
    var noteTimer;
    drawer.addEventListener('input', function (e) {
      if (!e.target.matches('[data-cart-note]')) return;
      clearTimeout(noteTimer);
      var val = e.target.value;
      noteTimer = setTimeout(function () {
        fetch(window.routes.cart_url + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: val }) });
      }, 500);
    });
  }

  /* Tabs ----------------------------------------------------------------- */
  $$('[data-tabs]').forEach(function (t) {
    var btns = $$('[role="tab"]', t), panels = $$('[role="tabpanel"]', t);
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        btns.forEach(function (x, j) { x.setAttribute('aria-selected', j === i ? 'true' : 'false'); x.tabIndex = j === i ? 0 : -1; });
        panels.forEach(function (p, j) {
          p.hidden = j !== i;
          var v = $('video', p); if (v) { if (j === i) v.play().catch(function () {}); else v.pause(); }
        });
      });
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + btns.length) % btns.length;
        btns[n].focus(); btns[n].click();
      });
    });
  });

  /* Before / after slider ------------------------------------------------ */
  $$('[data-ba]').forEach(function (ba) {
    var r = $('input[type="range"]', ba);
    if (!r) return;
    var set = function () { ba.style.setProperty('--pos', r.value + '%'); };
    r.addEventListener('input', set); set();
  });

  /* Lazy autoplay videos only while visible ------------------------------ */
  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) v.play().catch(function () {}); else v.pause();
      });
    }, { threshold: .25 });
    $$('video[data-autoplay]').forEach(function (v) { vio.observe(v); });
  }
})();
